<script setup lang="ts">
import ChevronDownIcon from '~/app/components/base/icons/ChevronDownIcon.vue';

const props = defineProps<{
  title: string;
  titleClass?: string;
  defaultOpen?: boolean;
}>();

const emit = defineEmits(['toggleCollapsible']);
const isOpen = ref(props.defaultOpen ?? false);
const toggleCollapsible = () => {
  isOpen.value = !isOpen.value;
  emit('toggleCollapsible', isOpen.value);
};

</script>

<template>
  <div class="s-collapsible" @click="toggleCollapsible">
    <p class="s-detail__title__secondary" :class="titleClass">
      {{ title }}
    </p>
    <button class="chevron-icon" :class="{ 'chevron-icon--open': isOpen }">
      <ChevronDownIcon />
    </button>
  </div>
</template>

<style scoped>
.s-collapsible {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.chevron-icon {
  width: 24px;
  height: 24px;
}

.chevron-icon--open {
  transform: rotate(180deg);
}
</style>
